import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function AnnouncementBar() {
  return (
    <div
      data-testid="announcement-bar"
      className="w-full bg-[#00F22E] text-[#070807] text-xs sm:text-sm py-2"
    >
      <div className="ep-container flex items-center justify-center gap-2 text-center">
        <span className="font-semibold">
          İşyerinizin dijital satış potansiyelini ücretsiz analiz ediyoruz.
        </span>
        <Link
          to="/basvuru"
          className="inline-flex items-center gap-1 font-bold underline-offset-4 hover:underline"
          data-testid="announcement-cta"
        >
          Hemen Başvurun <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </div>
  );
}
